import {NotificationManager} from "react-notifications";


/**
 @typedef {(format: 'xls' | 'pdf') => Promise<any[]> | any[]} ReportData function returning an array of objects, or an array itself
 */


/**
 * @param {ReportData} rd
 * @param {'xls' | 'pdf'} format
 * */
export async function getReportRows(rd, format) {
    let data = null;
    if (typeof rd === "function") {
        try {
            data = await rd(format);
        } catch (e) {
            NotificationManager.error(e.message);
        }
    } else {
        data = [...rd];
    }
    return data;
}
